import React from 'react';
import { useState } from 'react';
import {
    Navbar,
    Container,
    Nav,
    NavDropdown,
    Button,
} from 'react-bootstrap';
import { useNavigate, NavLink } from 'react-router-dom';
import brandLogo from '../../../assets/icons/Agilisium new logo .png';
import MarketingHubLogo from '../../../assets/logo/MarketingHubWhite.png';
import { useSelector } from 'react-redux';
import HubSpoc from '../../hubspoc/HubSpoc';
import SearchBar from '../../searchBar/searchBar';

function TalentTransformationalHubNavBar({ hubId }) {
    const [show, setShow] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.authUser);
    // const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);

    const handleClose = (dropdown) => {
        setShow(false);
        setActiveDropdown(dropdown);
    };

    return (
        <>
            <Navbar
                expand="lg"
                className="bg-body-tertiary p-0"
                expanded={show}
                style={{ position: 'fixed', width: '100%', zIndex: '999', padding: '100px !important' }}
            >
                <Container
                    fluid
                    style={{
                        background: '#FFF',
                    }}
                    className="bg-white p-1 border border-gray-400 "
                >
                    <Navbar.Brand
                        className="brand"
                        onClick={() => { navigate('/talentTransformationalHub'); handleClose('home') }}
                    >
                        <img
                            src={brandLogo}
                            alt="brand"
                            style={{
                                top: '19px',
                                left: '48px',
                                height: '58px',
                                // background: 'white 0% 0% no-repeat padding-box',
                                opacity: '1',
                                cursor: 'pointer',
                            }}
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle
                        aria-controls="phNavbarScroll"
                        onClick={() => setShow(!show)}
                    />
                    <Navbar.Collapse id="phNavbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            // style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link
                                as={NavLink}
                                to="/talentTransformationalHub"
                                className={`px-4 navHeader ${activeDropdown === 'home' ? 'active' : ''}`}
                                onClick={() => handleClose('home')}
                            >
                                Home
                            </Nav.Link>
                            {(hasRole(6) || hasRole(14)) && <NavDropdown
                                title={hasRole(6) ? "Super Admin" : "Admin"}
                                id="navbarScrollingDropdown"
                                className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to="/managelearninglounge"
                                    className="bg-transparent menulink"
                                    onClick={() => handleClose('admin')}
                                >
                                    Manage Learning Hub
                                </NavDropdown.Item>
                            </NavDropdown>}
                            <NavLink>
                                <HubSpoc hubId={hubId} />
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Brand
                        className="brand"
                        onClick={() => navigate('/')}
                    >
                        <Button className='backtohomebtn'>Go to Agilisium Page</Button>
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    );
}

export default TalentTransformationalHubNavBar